export const LAZADA_SUBSCRIPTION_STATUS_ACTIVE = 1;
export const LAZADA_SUBSCRIPTION_STATUS_EXPIRED = 2;
